import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ModalBody, ModalFooter } from 'reactstrap'
import TextEditor from '../../../../TextEditor'
import CustomModal from '../CustomModal'
import CancelModalButton from 'components/Custom/CancelModalButton'
import DeleteButton from 'components/Custom/DeleteButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'

export default function ManageHtml(props) {
  let language = props.language || {}
  const html = props.content.find((item) =>
    item.id === parseInt(props.match.params.id) ? item : null
  )

  useEffect(() => {
    props.fetchHtmlContent(props.match.params.id)
    return () => {
      props.manageHtml('')
      props.onChangeText('textContent', '')
    }
  }, [])

  return (
    <CustomModal courseId={props.course_id} title='Edit Html' size='xl'>
      <ModalBody>
        <div className='row'>
          <div className='col-md-4 title-container'>
            <div className='upload-video-form-row'>
              <label>
                {language.settings ? language.settings.title : null}:{' '}
              </label>
              <input
                type='text'
                name='title'
                autoFocus
                value={props.title ? props.title : ''}
                onChange={(event) =>
                  props.onChangeTitleText(event.target.value)
                }
              />
            </div>
          </div>
        </div>

        <TextEditor
          textContent={props.html}
          onChangeText={(e) => props.manageHtml(e)}
          setOptions={{
            buttonList: [
              [
                'undo',
                'redo',
                'font',
                'fontSize',
                'formatBlock',
                'list',
                'align',
                'fontColor',
              ],
              ['bold', 'underline', 'italic', 'horizontalRule'],
              ['codeView', 'outdent', 'indent'],
              ['table', 'image', 'link'],
            ],
          }}
        />
        <div className='custom-control custom-checkbox-info mt-2'>
          <input
            className='custom-control-input'
            id='required_content'
            type='checkbox'
            checked={props.requiredContent}
            onChange={props.setRequired}
          />
          <label
            className='custom-control-label '
            htmlFor='required_content'
            style={{ fontSize: '14px', paddingTop: '2px' }}
          >
            {language?.courses?.required}
          </label>
        </div>
      </ModalBody>
      <ModalFooter className='d-flex justify-content-start mt-3'>
        <Link to={`/course/${props.id}/edit`}>
          <SubmitModalButton
            text={language.general ? language.general.submit : null}
            customFn={() => props.saveHtml(html.id)}
          />
        </Link>
        <Link to={`/course/${props.id}/edit`}>
          <DeleteButton
            text={language.general ? language.general.delete : null}
            customFn={() => props.deleteContent(html.id)}
          />
        </Link>
        <Link to={`/course/${props.id}/edit`}>
          <CancelModalButton
            text={language.general ? language.general.cancel : null}
          />
        </Link>
      </ModalFooter>
    </CustomModal>
  )
}
